import { render } from "./LimitLabel.vue?vue&type=template&id=2b5a148c"
import script from "./LimitLabel.vue?vue&type=script&lang=js"
export * from "./LimitLabel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__